// import "../../../css/sidebar.css";
// import React, { useState } from 'react';
// import classNames from 'classnames';
// import styles from './Sidebar.module.scss';
// import { useNavigate } from 'react-router-dom';

// import '../../../css/sidebar.css'
// import { Helmet } from 'react-helmet';

// const cx = classNames.bind(styles);

// const MenuItem = ({ title, to, children, isCollapsed }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const navigate = useNavigate();

//     const toggleMenu = () => {
//         if (!children) {
//             navigate(to);
//         } else {
//             setIsOpen(prevIsOpen => !prevIsOpen);
//         }
//     };

//     return (
//         <div className={cx('menuItem', { collapsed: isCollapsed })}>
//             <div className={cx('navLink')} onClick={toggleMenu} style={{ cursor: 'pointer' }}>
//                 {isCollapsed ? <span>📄</span> : title}
//                 {children && !isCollapsed && <span>{isOpen ? '▲' : '▼'}</span>}
//             </div>
//             {isOpen && !isCollapsed && (
//                 <ul className={cx('dropdownMenu')} style={{ paddingLeft: '15px' }}>
//                     {children}
//                 </ul>
//             )}
//         </div>
//     );
// };

// const Sidebar = () => {
//     const [isCollapsed, setIsCollapsed] = useState(false);

//     const toggleSidebar = () => {
//         setIsCollapsed(prev => !prev);
//     };

//     return (
//         <div className={cx('sidebar', { collapsed: isCollapsed })}>
//             <button className={cx('toggleButton')} onClick={toggleSidebar}>
//                 {isCollapsed ? '➡️' : '⬅️'}
//             </button>

//             <MenuItem title="Tổng quan" to="/overview" isCollapsed={isCollapsed} />
//             <MenuItem title="Cloud Hosting" isCollapsed={isCollapsed}>
//                 <MenuItem title="Quản lý Hosting" to="/quanlyhosting" isCollapsed={isCollapsed} />
//                 <MenuItem title="Đăng ký Hosting" to="/dangkyhosting" isCollapsed={isCollapsed} />
//             </MenuItem>
//             <MenuItem title="Tên miền" to="/tenmien" isCollapsed={isCollapsed} />
//             <MenuItem title="Cloud VPS" to="/cloudvps" isCollapsed={isCollapsed} />
//             <MenuItem title="Email" to="/email" isCollapsed={isCollapsed} />
//             <MenuItem title="Máy chủ riêng" to="/maychurieng" isCollapsed={isCollapsed} />
//             <MenuItem title="Chứng chỉ SSL" to="/chungchissl" isCollapsed={isCollapsed} />
//             <MenuItem title="Chỗ đặt máy chủ" to="/chodatmachu" isCollapsed={isCollapsed} />
//             <MenuItem title="Quản lý giao dịch" to="/quanlygiaodich" isCollapsed={isCollapsed} />
//             <MenuItem title="Quản lý ticket" to="/quanlyticket" isCollapsed={isCollapsed} />
//         </div>
//     );
// };

// export default Sidebar;

// import React, { useState, useEffect } from 'react';
// import { useTranslation } from 'react-i18next';

// import { useNavigate, Link, useLocation } from 'react-router-dom';
// import "./Sidebar.css"
// function Sidebar({ toggleSidebar }) {


//     const [openSection, setOpenSection] = useState(null);
//     const navigate = useNavigate();
//     const location = useLocation();
//     const { t, i18n } = useTranslation();
//     const handleDashboard = () => {
//         setOpenSection(null);
//         navigate('/dashboard');
//         toggleSidebar(false);
//     };
//     const handleTicket = () => {
//         setOpenSection(null);
//         navigate('/tickets');
//     };



//     const toggleSection = (section) => {
//         setOpenSection(openSection === section ? null : section);
//     };
//     const isActive = (path) => location.pathname === path;

//     useEffect(() => {
//         const language = localStorage.getItem('language') || 'en';
//         i18n.changeLanguage(language);
//     }, [i18n]);

//     return (
//         <div style={{}} className="sidebar">
//             <nav className="sidebar-nav">
//                 <ul style={{ paddingTop: "20px", cursor: "pointer" }} className="nav">
//                     <li className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}>
//                         <a className="nav-link" onClick={() => handleDashboard()}>
//                             <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>  {t("Dashboard")}
//                         </a>
//                     </li>

//                     {/* Server Section */}
//                     <li className={`nav-item nav-dropdown ${openSection === 'server' ? 'open' : ''}`}>
//                         <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('server')}>
//                             <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg> CSSP
//                         </a>
//                         {openSection === 'server' && (
//                             <ul className="nav-dropdown-items">
//                                 <li className={`nav-item ${isActive('/cssp') ? 'active' : ''}`}>
//                                     <Link className="nav-link" to="/cssp">{t("CSSP Management")}</Link>
//                                 </li>
//                                 <li className={`nav-item ${isActive('/cssp/create') ? 'active' : ''}`}>
//                                     <Link className="nav-link" to="/cssp/create">{t("CSSP Create")}</Link>
//                                 </li>
//                             </ul>
//                         )}
//                     </li>

//                     <li className={`nav-item nav-dropdown ${openSection === 'cshp' ? 'open' : ''}`}>
//                         <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('cshp')}>
//                             <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
//                                 <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"></circle>
//                                 <line x1="12" y1="6" x2="12" y2="12" stroke="currentColor" strokeWidth="2"></line>
//                                 <line x1="12" y1="12" x2="16" y2="12" stroke="currentColor" strokeWidth="2"></line>
//                             </svg> CSHP
//                         </a>

//                         {openSection === 'cshp' && (
//                             <ul className="nav-dropdown-items">
//                                 <li className={`nav-item ${isActive('/cshp') ? 'active' : ''}`}>
//                                     <Link className="nav-link" to="/cshp">{t("CSHP Management")}</Link>
//                                 </li>
//                                 <li className={`nav-item ${isActive('/cshp/create') ? 'active' : ''}`}>
//                                     <Link className="nav-link" to="/cshp/create">{t("CSHP Create")}</Link>
//                                 </li>
//                             </ul>
//                         )}
//                     </li>

//                     <li className={`nav-item nav-dropdown ${openSection === 'wh-panel' ? 'open' : ''}`}>
//                         <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('wh-panel')}>
//                             <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
//                                 <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"></circle>
//                                 <line x1="12" y1="6" x2="12" y2="12" stroke="currentColor" strokeWidth="2"></line>
//                                 <line x1="12" y1="12" x2="16" y2="12" stroke="currentColor" strokeWidth="2"></line>
//                             </svg> WH Panel
//                         </a>

//                         {openSection === 'wh-panel' && (
//                             <ul className="nav-dropdown-items">
//                                 <li className={`nav-item ${isActive('/wh-panel') ? 'active' : ''}`}>
//                                     <Link className="nav-link" to="/wh-panel">{t("Panel Management")}</Link>
//                                 </li>
//                                 <li className={`nav-item ${isActive('/wh-panel/create') ? 'active' : ''}`}>
//                                     <Link className="nav-link" to="/wh-panel/create">{t("Panel Create")}</Link>
//                                 </li>
//                             </ul>
//                         )}
//                     </li>


//                     {/* Hosting Section */}
//                     {/* <li className={`nav-item nav-dropdown ${openSection === 'hosting' ? 'open' : ''}`}>
//                         <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('hosting')}>
//                             HOSTING
//                         </a>
//                         {openSection === 'hosting' && (
//                             <ul className="nav-dropdown-items">
//                                 <li className="nav-item">
//                                     <Link className="nav-link" to="#">Quản lý Hosting</Link>
//                                 </li>
//                                 <li className="nav-item">
//                                     <Link className="nav-link" to="/cssp/hosting">Tạo hosting</Link>
//                                 </li>
//                             </ul>
//                         )}
//                     </li> */}

//                     {/* Email Section */}
//                     {/* <li className={`nav-item nav-dropdown ${openSection === 'email' ? 'open' : ''}`}>
//                         <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('email')}>
//                             Email
//                         </a>
//                         {openSection === 'email' && (
//                             <ul className="nav-dropdown-items">
//                                 <li className="nav-item"> <a className="nav-link" href="#">Quản lý email server</a> </li>
//                                 <li className="nav-item"> <a className="nav-link" href="#">Tạo email server</a> </li>
//                             </ul>
//                         )}
//                     </li> */}

//                     {/* Transaction Section */}
//                     <li className={`nav-item nav-dropdown ${openSection === 'transaction' ? 'open' : ''}`}>
//                         <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('transaction')}>

//                             <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg> {t("Transaction Management")}
//                         </a>
//                         {openSection === 'transaction' && (
//                             <ul className="nav-dropdown-items">

//                                 <li className={`nav-item ${isActive('/recharge') ? 'active' : ''}`}>
//                                     <Link className="nav-link" to="/recharge">{t("Add funds")}</Link>
//                                 </li>
//                                 <li className={`nav-item ${isActive('/invoice') ? 'active' : ''}`}>
//                                     <Link className="nav-link" to="/invoice">{t("Invoice")}</Link>
//                                 </li>
//                                 <li className={`nav-item ${isActive('/transaction-list') ? 'active' : ''}`}>
//                                     <Link className="nav-link" to="/transaction-list">{t("Transaction")}</Link>
//                                 </li>
//                             </ul>
//                         )}
//                     </li>

//                     {/* Transaction Section */}
//                     {/* <li className={`nav-item nav-dropdown ${openSection === 'transaction' ? 'open' : ''}`}>
//                         <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('transaction')}>

//                             <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg> Quản Lý Giao Dịch
//                         </a>
//                         {openSection === 'transaction' && (
//                             <ul className="nav-dropdown-items">
//                                 <li className="nav-item"> <a className="nav-link" href="#">Hóa Đơn</a> </li>
//                                 <li className="nav-item"> <a className="nav-link" href="#">Lịch Sử Nạp Tiền</a> </li>
//                                 <li className="nav-item"> <a className="nav-link" href="#">Lịch Sử Thanh Toán</a> </li>
//                             </ul>
//                         )}
//                     </li> */}

//                     {/* affiliate Section */}
//                     {/* <li className={`nav-item nav-dropdown ${openSection === 'affiliate' ? 'open' : ''}`}>
//                         <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('affiliate')}>

//                             <svg class="undefined" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.4607 16.1017H14.539C15.2068 16.1017 15.75 15.5585 15.75 14.8907C15.75 11.6463 15.75 12.3669 15.75 9.01869C15.75 8.35094 15.2068 7.80771 14.539 7.80771H13.7364V5.8102C13.7364 5.14273 13.1932 4.5995 12.5257 4.5995H11.6256V2.53758C11.6256 2.37883 11.497 2.25 11.338 2.25H5.6296C5.47057 2.25 5.34202 2.37883 5.34202 2.53758V4.5995H4.13995C3.63296 4.5995 3.15817 4.79735 2.80387 5.15539C2.44785 5.51112 2.25201 5.98447 2.25115 6.48859C2.25115 6.48946 2.25058 6.49003 2.25058 6.49061V8.09241C2.25058 8.09327 2.25 8.09413 2.25 8.09528V14.891C2.24971 15.5585 2.79294 16.1017 3.4607 16.1017ZM15.1751 12.8668H13.3553C12.8521 12.8668 12.4429 12.4575 12.4429 11.9546C12.4429 11.4516 12.8521 11.0424 13.3553 11.0424H15.1751V12.8668ZM15.1751 9.01869V10.4672H13.3553C12.5349 10.4672 11.8677 11.1344 11.8677 11.9546C11.8677 12.7747 12.5349 13.4419 13.3553 13.4419H15.1751V14.8907C15.1751 15.2413 14.8899 15.5266 14.5393 15.5266H3.4607C3.11014 15.5266 2.82487 15.2413 2.82487 14.8907C2.82487 14.6092 2.82544 11.5344 2.82544 7.84567C3.16306 8.17322 3.62145 8.37653 4.12701 8.37998C4.13133 8.38027 4.13507 8.38257 4.13938 8.38257H14.5393C14.8896 8.38257 15.1751 8.66785 15.1751 9.01869ZM9.8426 7.80569H7.125V4.82928C7.51265 4.72632 7.81835 4.42034 7.92159 4.03269H9.04601C9.14896 4.42034 9.45495 4.72632 9.8426 4.82928V7.80569ZM12.5257 5.17437C12.8762 5.17437 13.1612 5.45936 13.1612 5.80991V7.80569H11.6256V5.17437H12.5257ZM5.91718 2.82487H11.0504V7.80569H10.4178V4.57908C10.4178 4.42034 10.2892 4.29151 10.1302 4.29151C9.82908 4.29151 9.58407 4.04649 9.58407 3.74511C9.58407 3.58637 9.45552 3.45753 9.29649 3.45753H7.67168C7.51265 3.45753 7.38411 3.58637 7.38411 3.74511C7.38411 4.04649 7.1388 4.29151 6.838 4.29151C6.67897 4.29151 6.55042 4.42034 6.55042 4.57908V7.80569H5.91775V2.82487H5.91718ZM3.21137 5.56087C3.45782 5.31154 3.78767 5.17437 4.13995 5.17437H5.34231V7.80569H4.13995C3.41526 7.80569 2.82602 7.21616 2.82602 6.49147C2.82573 6.13976 2.96233 5.80962 3.21137 5.56087Z" fill="#ffffff" stroke="#ffffff" stroke-width="0.5"></path></svg> Affiliate

//                         </a>
//                         {openSection === 'affiliate' && (
//                             <ul className="nav-dropdown-items">
//                                 <li className="nav-item"> <a className="nav-link" href="#">Phương thức chia sẻ</a> </li>
//                                 <li className="nav-item"> <a className="nav-link" href="#">Thống kê lượt click</a> </li>
//                                 <li className="nav-item"> <a className="nav-link" href="#">Thống kê doanh thu</a> </li>
//                                 <li className="nav-item"> <a className="nav-link" href="#"> Thống kê rút tiền</a> </li>

//                             </ul>
//                         )}
//                     </li> */}

//                     {/* User Section */}
//                     <li className={`nav-item nav-dropdown ${openSection === 'user' ? 'open' : ''}`}>
//                         <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('user')}>
//                             <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg> {t("Account Information")}
//                         </a>
//                         {openSection === 'user' && (
//                             <ul className="nav-dropdown-items">
//                                 <li className={`nav-item ${isActive('/account/update-info') ? 'active' : ''}`}>
//                                     <Link className="nav-link" to="/account/update-info">{t("Update information")}</Link>

//                                 </li>
//                                 <li className={`nav-item ${isActive('/account/change-password') ? 'active' : ''}`}>
//                                     <Link className="nav-link" to="/account/change-password">{t("Change password")}</Link>

//                                 </li>
//                                 <li className={`nav-item ${isActive('/account/device') ? 'active' : ''}`} >
//                                     <Link className="nav-link" to="/account/device">{t("Logged-in device")}</Link>

//                                 </li>                            </ul>
//                         )}
//                     </li>

//                     {/* Ticket Section */}
//                     {/* <li className={`nav-item nav-dropdown ${openSection === 'ticket' ? 'open' : ''}`}>
//                         <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('ticket')}>
//                             <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="text-[#828282]" height="18" width="18" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4 1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10z"></path></svg>  Quản Lý Ticket
//                         </a>
//                         {openSection === 'ticket' && (
//                             <ul className="nav-dropdown-items">

//                                 <li className={`nav-item ${isActive('/tickets') ? 'active' : ''}`}> <Link className="nav-link" to="/tickets/">Danh Sách Ticket</Link> </li>
//                                 <li className={`nav-item ${isActive('/tickets/add') ? 'active' : ''}`}> <Link className="nav-link" to="/tickets/add">Tạo Ticket</Link> </li>
//                             </ul>
//                         )}
//                     </li> */}
//                     <li className={`nav-item ${isActive('/tickets') ? 'active' : ''}`}>
//                         <a className="nav-link" onClick={handleTicket}>
//                             <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" className="text-[#828282]" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
//                                 <path d="M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4 1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10z"></path>
//                             </svg> {t("Support")}
//                         </a>
//                     </li>

//                 </ul>
//             </nav>
//         </div>
//     );
// }




// export default Sidebar;
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

function Sidebar({ toggleSidebar, isSidebarVisible }) {
    const [openSection, setOpenSection] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const { t, i18n } = useTranslation();

    const [isMobile, setIsMobile] = useState(false); // Để kiểm tra nếu màn hình là điện thoại
    const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
    };
    useEffect(() => {
        // Hàm kiểm tra kích thước màn hình
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        // Kiểm tra kích thước màn hình khi component mount và khi kích thước cửa sổ thay đổi
        checkMobile();
        window.addEventListener('resize', checkMobile);

        // Cleanup khi component unmount
        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);

    const handleDashboard = () => {
        setOpenSection(null);
        navigate('/dashboard');
        if (isMobile) toggleSidebar(false);  // Chỉ đóng sidebar nếu là điện thoại
    };

    const handleTicket = () => {
        setOpenSection(null);
        navigate('/tickets');
        if (isMobile) toggleSidebar(false);  // Chỉ đóng sidebar nếu là điện thoại
    };

    const handleSubMenuClick = (section) => {
        // Nếu mục con được bấm, thì sẽ đóng sidebar
        setOpenSection(openSection === section ? null : section);
        if (isMobile && openSection !== section) {
            toggleSidebar(false);  // Chỉ đóng sidebar khi chọn mục con
        }
    };

    const isActive = (path) => location.pathname === path;

    useEffect(() => {
        const language = localStorage.getItem('language') || 'en';
        i18n.changeLanguage(language);
    }, [i18n]);

    return (
        <div className={`sidebar ${isSidebarVisible ? 'visible' : ''}`}>
            <nav className="sidebar-nav">
                <ul style={{ paddingTop: "20px", cursor: "pointer" }} className="nav">
                    <li className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}>
                        <a className="nav-link" onClick={handleDashboard}>
                            <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                <polyline points="9 22 9 12 15 12 15 22"></polyline>
                            </svg> {t("Dashboard")}
                        </a>
                    </li>

                    {/* Server Section */}
                    <li className={`nav-item nav-dropdown ${openSection === 'server' ? 'open' : ''}`}>
                        <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('server')}>
                            <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg> CSSP
                        </a>
                        {openSection === 'server' && (
                            <ul className="nav-dropdown-items">
                                <li className={`nav-item ${isActive('/cssp') ? 'active' : ''}`}>
                                    <Link onClick={() => isMobile && toggleSidebar(false)} className="nav-link" to="/cssp">{t("CSSP Management")}</Link>
                                </li>
                                <li className={`nav-item ${isActive('/cssp/create') ? 'active' : ''}`}>
                                    <Link onClick={() => isMobile && toggleSidebar(false)} className="nav-link" to="/cssp/create">{t("CSSP Create")}</Link>
                                </li>
                            </ul>
                        )}
                    </li>

                    <li className={`nav-item nav-dropdown ${openSection === 'cshp' ? 'open' : ''}`}>                        <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('cshp')}>
                        <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"></circle>
                            <line x1="12" y1="6" x2="12" y2="12" stroke="currentColor" strokeWidth="2"></line>
                            <line x1="12" y1="12" x2="16" y2="12" stroke="currentColor" strokeWidth="2"></line>
                        </svg> CSHP
                    </a>

                        {openSection === 'cshp' && (
                            <ul className="nav-dropdown-items">
                                <li className={`nav-item ${isActive('/cshp') ? 'active' : ''}`}>
                                    <Link onClick={() => isMobile && toggleSidebar(false)} className="nav-link" to="/cshp">{t("CSHP Management")}</Link>
                                </li>
                                <li className={`nav-item ${isActive('/cshp/create') ? 'active' : ''}`}>
                                    <Link onClick={() => isMobile && toggleSidebar(false)} className="nav-link" to="/cshp/create">{t("CSHP Create")}</Link>
                                </li>
                            </ul>
                        )}
                    </li>

                    {/* <li className={`nav-item nav-dropdown ${openSection === 'wh-panel' ? 'open' : ''}`}>
                        <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('wh-panel')}>
                            <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"></circle>
                                <line x1="12" y1="6" x2="12" y2="12" stroke="currentColor" strokeWidth="2"></line>
                                <line x1="12" y1="12" x2="16" y2="12" stroke="currentColor" strokeWidth="2"></line>
                            </svg> WH Panel
                        </a>

                        {openSection === 'wh-panel' && (
                            <ul className="nav-dropdown-items">
                                <li className={`nav-item ${isActive('/wh-panel') ? 'active' : ''}`}>
                                    <Link onClick={() => isMobile && toggleSidebar(false)} className="nav-link" to="/wh-panel">{t("Panel Management")}</Link>
                                </li>
                                <li className={`nav-item ${isActive('/wh-panel/create') ? 'active' : ''}`}>
                                    <Link onClick={() => isMobile && toggleSidebar(false)} className="nav-link" to="/wh-panel/create">{t("Panel Create")}</Link>
                                </li>
                            </ul>
                        )}
                    </li> */}
                    {/* Transaction Section */}
                    <li className={`nav-item nav-dropdown ${openSection === 'transaction' ? 'open' : ''}`}>
                        <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('transaction')}>

                            <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg> {t("Transaction Management")}
                        </a>
                        {openSection === 'transaction' && (
                            <ul className="nav-dropdown-items">

                                <li className={`nav-item ${isActive('/recharge') ? 'active' : ''}`}>
                                    <Link onClick={() => isMobile && toggleSidebar(false)} className="nav-link" to="/recharge">{t("Add funds")}</Link>
                                </li>
                                <li className={`nav-item ${isActive('/invoice') ? 'active' : ''}`}>
                                    <Link onClick={() => isMobile && toggleSidebar(false)} className="nav-link" to="/invoice">{t("Invoice")}</Link>
                                </li>
                                <li className={`nav-item ${isActive('/transaction-list') ? 'active' : ''}`}>
                                    <Link onClick={() => isMobile && toggleSidebar(false)} className="nav-link" to="/transaction-list">{t("Transaction")}</Link>
                                </li>
                            </ul>
                        )}
                    </li>

                    {/* User Section */}
                    <li className={`nav-item nav-dropdown ${openSection === 'user' ? 'open' : ''}`}>
                        <a className="nav-link nav-dropdown-toggle" onClick={() => toggleSection('user')}>
                            <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg> {t("Account Information")}
                        </a>
                        {openSection === 'user' && (
                            <ul className="nav-dropdown-items">
                                <li className={`nav-item ${isActive('/account/update-info') ? 'active' : ''}`}>
                                    <Link onClick={() => isMobile && toggleSidebar(false)} className="nav-link" to="/account/update-info">{t("Update information")}</Link>

                                </li>
                                <li className={`nav-item ${isActive('/account/change-password') ? 'active' : ''}`}>
                                    <Link onClick={() => isMobile && toggleSidebar(false)} className="nav-link" to="/account/change-password">{t("Change password")}</Link>

                                </li>
                                <li className={`nav-item ${isActive('/account/device') ? 'active' : ''}`} >
                                    <Link onClick={() => isMobile && toggleSidebar(false)} className="nav-link" to="/account/device">{t("Logged-in device")}</Link>

                                </li>                            </ul>
                        )}
                    </li>




                    {/* Ticket Section */}
                    <li className={`nav-item ${isActive('/tickets') ? 'active' : ''}`}>
                        <a className="nav-link" onClick={handleTicket}>
                            <svg style={{ position: 'relative', top: "-2px" }} stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" className="text-[#828282]" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4 1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10z"></path>
                            </svg> {t("Support")}
                        </a>
                    </li>

                </ul>
            </nav>
        </div>
    );
}

export default Sidebar;

